import { axiosInstance, handleAxiosResponse } from "../../../core/sources/network";

import { actions } from "../slice";
import { handleError } from "../../app-messages";
import { appLocalStorage, lskeys } from "../../../core/sources/local-storage";
import { getAppStoreCurrentState } from "../../../store";

export const updateProfile = ({ profileDetails }) => {
  return async (dispatch) => {
    try {
      const { mainProfile } = getAppStoreCurrentState();

      const response = await axiosInstance.put(`/recruiters/${mainProfile.email}/profile`, {
        profileDetails,
      });

      const { data: updatedRecruiterProfile } = handleAxiosResponse(response);

      const recruiterProfile = { ...mainProfile, ...updatedRecruiterProfile };

      appLocalStorage.save({ [lskeys.recruiterProfile]: recruiterProfile });

      dispatch(actions.setProfile({ profile: recruiterProfile }));
    } catch (error) {
      handleError(error?.response?.data?.message ?? error.message)(dispatch);
    }
  };
};
